/* global angular */
( function () {
	'use strict';

	function observationService ( apiService ) {
		function arraycheck ( array ) {
			return angular.isArray( array ) && array.length;
		}

		function normalizePpd ( ppd ) {
			var data = {
				'resourceId' : ppd.id || ppd.ContentId || ppd.resourceId,
				'id'         : apiService.generateUUID(),
				'type'       : ppd.type
			};

			if ( ppd.dueDate ) {
				data.dueDate = ppd.dueDate;
			}

			return data;
		}

		function attachProperty ( source, destination, key ) {
			if ( arraycheck( source ) ) {
				destination[ key ] = source;
			}
		}

		function mapNormalizePpd ( masterPrescribedResources, model ) {
			var indicatorPrescribedResources = ( model.prescribedResources || [] ).map( function ( ppd ) {
				var masterPpdElem = masterPrescribedResources.filter( function ( masterPpd ) {
					return masterPpd.resourceId === ppd.id || masterPpd.resourceId === ppd.contentId;
				} );

				if ( arraycheck( masterPpdElem ) ) {
					return masterPpdElem[ 0 ].id;
				}

				var normalizedPpd = normalizePpd( ppd );

				masterPrescribedResources.push( normalizedPpd );
				delete normalizedPpd.contentId;
				return normalizedPpd.id;
			} );

			attachProperty( indicatorPrescribedResources, model, 'prescribedResources' );
		}

		function dettachDataFromIndicatorPpd ( masterPrescribedResources, group ) {
			( group.indicators || [] ).map( function ( indicator ) {
				if ( !arraycheck( indicator.prescribedResources ) ) {
					delete indicator.prescribedResources;
				}
				mapNormalizePpd( masterPrescribedResources, indicator );
			} );
		}

		function dettachDataFromGroupPpd ( masterPrescribedResources, normalizedData ) {
			normalizedData.template.groups.map( function ( group ) {
				if ( !arraycheck( group.prescribedResources ) ) {
					delete group.prescribedResources;
				}
				mapNormalizePpd( masterPrescribedResources, group );
				dettachDataFromIndicatorPpd( masterPrescribedResources, group );
			} );
		}

		function dettachDataFromIndicatorEvidences ( indicators ) {
			var indicatorEvidenceIds = [ ];

			( indicators || [ ] ).forEach( function ( indicator ) {
				if ( !arraycheck( indicator.evidences ) ) {
					delete indicator.evidences;
				} else {
					indicator.evidences.forEach( function ( evidence ) {
						indicatorEvidenceIds.push( evidence.id );
					} );

					attachProperty( indicatorEvidenceIds, indicator, 'evidences' );

					indicatorEvidenceIds = [ ];
				}
			} );
		}

		function dettachDataFromGroupEvidences ( groups ) {
			var groupEvidenceIds = [ ];

			groups.forEach( function ( group ) {
				if ( !arraycheck( group.evidences ) ) {
					delete group.evidences;
				} else {
					group.evidences.forEach( function ( evidence ) {
						groupEvidenceIds.push( evidence.id );
					} );

					attachProperty( groupEvidenceIds, group, 'evidences' );

					groupEvidenceIds = [ ];
				}

				dettachDataFromIndicatorEvidences( group.indicators );
			} );
		}

		function normalize ( data, ctrl, isFinal ) {
			var isSelfObs = data.observee.id === data.observer.id;

			( data.masterPrescribedResources || [] )
				.filter( function ( pd ) {
					return !ctrl.hasSigned && !isSelfObs && pd.type === 4 && !isFinal && ctrl.autoSaveCount > 1;
				} )
				.forEach( function ( item ) {
					item.assignedDate = new Date();
					delete item.completedDate;
				} );

			Object.keys( data.digitalSignature || {} )
				.filter( function () {
					return !ctrl.hasSigned && !isSelfObs && !isFinal && ctrl.autoSaveCount > 1;
				} )
				.forEach( function ( key ) {
					data.digitalSignature[ key ].forEach( function ( item ) {
						item.isValid = false;
					} );
				} );

			var normalizedData            = angular.copy( data );
			var masterPrescribedResources = [ ];
			var evidenceIds               = [ ];
			var hasPrescribedResources    = arraycheck( normalizedData.prescribedResources );
			var hasEvidences              = arraycheck( normalizedData.evidences );

			if ( !hasPrescribedResources ) {
				// Removed Empty prescribedResources
				delete normalizedData.prescribedResources;
			} else {
				// bind all pdd to master
				masterPrescribedResources = angular.copy( normalizedData.prescribedResources ).map( function ( ppd ) {
					return normalizePpd( ppd );
				} );
				// return generated uuid from master to ppd
				normalizedData.prescribedResources = angular.copy( masterPrescribedResources ).map( function ( ppd ) {
					return ppd.id;
				} );
			}

			var sigPdsExtracted = ( normalizedData.masterPrescribedResources || [] ).filter( function ( pd ) {
				return pd.type === 4;
			} );

			delete normalizedData.masterPrescribedResources;
			dettachDataFromGroupPpd( masterPrescribedResources, normalizedData );
			attachProperty( masterPrescribedResources.concat( sigPdsExtracted ), normalizedData, 'masterPrescribedResources' );

			if ( !hasEvidences ) {
				// remove empty evidences attached in obs level
				delete  normalizedData.evidences;
			} else {
				// normalize evidences attached in obs level
				normalizedData.evidences.forEach( function ( evidence ) {
					evidenceIds.push( evidence.id );
				} );

				attachProperty( evidenceIds, normalizedData, 'evidences' );
			}

			dettachDataFromGroupEvidences( normalizedData.template.groups );

			return normalizedData;
		}

		function combineWithData ( masterSource, data ) {
			return angular.copy( masterSource )
				// lookup ppd from master
				.filter( function ( item ) {
					return item.id === data;
				} )
				// transform data
				.map( function ( result ) {
					// if not evidence
					if ( !result.scope ) {
						result.id        = result.resourceId;
						result.contentId = result.resourceId;
						result.name      = result.contentName;

						delete result.isAttached;
					}

					return result;
				} )[ 0 ];
		}

		function mapDenormalize ( denormalizedData, model ) {
			model = model || denormalizedData;
			if ( arraycheck( model.prescribedResources ) ) {
				model.prescribedResources = model.prescribedResources.map( function ( ppd ) {
					return combineWithData( denormalizedData.masterPrescribedResources, ppd );
				} );
			}

			if ( arraycheck( model.evidences ) ) {
				model.evidences = model.evidences.map( function ( evidence ) {
					return combineWithData( denormalizedData.masterEvidences, evidence );
				} );
			}
		}

		function attachDataToIndicator ( denormalizedData, group ) {
			( group.indicators || [] ).map( function ( indicator ) {
				mapDenormalize( denormalizedData, indicator );
			} );
		}

		function attachDataToGroup ( denormalizedData ) {
			denormalizedData.template.groups.map( function ( group ) {
				mapDenormalize( denormalizedData, group );
				attachDataToIndicator( denormalizedData, group );
			} );
		}

		function denormalize ( data ) {
			var denormalizedData = angular.copy( data );

			if ( !arraycheck( denormalizedData.masterEvidences ) ) {
				denormalizedData.masterEvidences = [ ];
			}

			if ( arraycheck( denormalizedData.masterPrescribedResources ) || arraycheck( denormalizedData.masterEvidences ) ) {
				mapDenormalize( denormalizedData );
				attachDataToGroup( denormalizedData );
			}

			return denormalizedData;
		}

		function getAllAttachedEvidences ( observation ) {
			var attachedEvidences = [ ];

			if ( arraycheck( observation.evidences ) ) {
				attachedEvidences.push.apply( attachedEvidences, observation.evidences );
			}

			observation.template.groups.forEach( function ( group ) {
				if ( arraycheck( group.evidences ) ) {
					attachedEvidences.push.apply( attachedEvidences, group.evidences );
				}

				if ( arraycheck( group.indicators ) ) {
					group.indicators.forEach( function ( indicator ) {
						if ( arraycheck( indicator.evidences ) ) {
							attachedEvidences.push.apply( attachedEvidences, indicator.evidences );
						}
					} );
				}
			} );

			return attachedEvidences;
		}

		function getUnAttachedEvidences ( masterEvidences, allAttachedEvidences ) {
			var allUnAttachedEvidences = [ ];

			allUnAttachedEvidences = masterEvidences.filter( function ( masterEvidence ) {
				var attached = allAttachedEvidences.some( function ( attachedEvidence ) {
					return masterEvidence.id === attachedEvidence.id;
				} );

				return !attached;
			} );

			return allUnAttachedEvidences;
		}

		function hasUnAttachedEvidences ( observation ) {
			var masterEvidences      = observation.masterEvidences;
			var allAttachedEvidences = getAllAttachedEvidences( observation );

			return getUnAttachedEvidences( masterEvidences, allAttachedEvidences );
		}

		function getValidSignature ( userArr ) {
			return Boolean( ( ( userArr || [] ).sort( function ( a, b ) {
				return parseInt( a.date, 10 ) > parseInt( b.date, 10 ) && 1 || -1;
			} ).pop() || {} ).isValid );
		}

		function maskUtil () {
			function subOptionMask ( subOption ) {
				delete subOption.tempValue;
				delete subOption.selectAll;
			}

			// TODO - needs to be resolved next sprint
			// start of quick fix
			function answerOptionMask ( answerOption ) {
				delete answerOption.tempValue;
				delete answerOption.selectAll;

				( answerOption.subOptions || [] ).map( subOptionMask );
			}

			function ppdMask ( ppd ) {
				delete ppd.name;
				delete ppd.description;
				delete ppd.segmentLengthInSeconds;

				return ppd;
			}

			function indicatorMask ( indicator ) {
				( indicator.answerOptions || [] ).map( answerOptionMask );

				if ( indicator.prescribedResources ) {
					indicator.prescribedResources = ( angular.copy( indicator.prescribedResources ) ).map( ppdMask );
				}

				delete indicator.tempValue;
				delete indicator.selectAll;
			}

			function rubricMask ( rubric ) {
				delete rubric.selected;
			}

			function groupMask ( group ) {
				if ( group.prescribedResources ) {
					group.prescribedResources = ( angular.copy( group.prescribedResources ) ).map( ppdMask );
				}
				if ( group.rubric ) {
					group.rubric.map( rubricMask );
				}

				delete group.score;

				if ( isNaN( group.manualScore ) || group.manualScore < 0 || group.manualScore === '' ) {
					delete group.manualScore;
				}

				( group.indicators || [] ).map( indicatorMask );
			}

			function prescribedResourcesMask ( ppd ) {
				var newPPD = { };

				newPPD.id   = ppd.ContentId || ppd.id || ppd.contentId;
				newPPD.type = ppd.type;

				if ( ppd.dueDate ) {
					newPPD.dueDate = ppd.dueDate;
				}

				return newPPD;
			}

			function openEndedMask ( group ) {
				( group.indicators || [] ).map( function ( indicator ) {
					/* if users try to delete the answer and triggers the autosave
					 * This prevents validation error
					*/
					if ( indicator.answerText === '' ) {
						delete indicator.answerText;
					}
				} );
			}

			return {
				'subOptionMask'           : subOptionMask,
				'answerOptionMask'        : answerOptionMask,
				'ppdMask'                 : ppdMask,
				'indicatorMask'           : indicatorMask,
				'rubricMask'              : rubricMask,
				'groupMask'               : groupMask,
				'prescribedResourcesMask' : prescribedResourcesMask,
				'openEndedMask'           : openEndedMask
			};
		}

		function checkIfSignatureComplete ( item ) {
			function getDigSigPD ( pd ) {
				return pd.type === 4;
			}

			function getCompletedDigitalSig ( pd ) {
				return pd.completedDate;
			}

			var pds = angular.extend( [], item.masterPrescribedResources ).filter( getDigSigPD );

			return pds.filter( getCompletedDigitalSig ).length === pds.length;
		}

		return {
			'normalize'                         : normalize,
			'denormalize'                       : denormalize,
			'hasUnAttachedEvidences'            : hasUnAttachedEvidences,
			'arraycheck'                        : arraycheck,
			'normalizePpd'                      : normalizePpd,
			'attachProperty'                    : attachProperty,
			'mapNormalizePpd'                   : mapNormalizePpd,
			'dettachDataFromIndicatorPpd'       : dettachDataFromIndicatorPpd,
			'dettachDataFromGroupPpd'           : dettachDataFromGroupPpd,
			'dettachDataFromIndicatorEvidences' : dettachDataFromIndicatorEvidences,
			'dettachDataFromGroupEvidences'     : dettachDataFromGroupEvidences,
			'combineWithData'                   : combineWithData,
			'mapDenormalize'                    : mapDenormalize,
			'attachDataToIndicator'             : attachDataToIndicator,
			'attachDataToGroup'                 : attachDataToGroup,
			'getValidSignature'                 : getValidSignature,
			'maskUtil'                          : maskUtil,
			'checkIfSignatureComplete'          : checkIfSignatureComplete,
			'dateInfo'                          : {
				'startDate' : null,
				'endDate'   : null
			}
		};
	}

	angular
		.module( 'app.observations' )
		.factory( 'observationService', observationService );

	observationService.$inject = [ 'apiService' ];
} )( );
